import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SellerLayout from './SellerLayout';

const SellerQnaView = () => {
  const [loading, setLoading] = useState(true);
  const [row, setRow] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const id = Number(new URLSearchParams(window.location.search).get('id') || 0);

      const res = await axios.get(`/api/seller/qna/view-data?id=${encodeURIComponent(id)}`, {
        withCredentials: true,
      });

      if (res.data && res.data.ok) {
        setRow(res.data.row);
      } else {
        alert(res.data?.error || 'Q&A 상세를 불러오지 못했습니다.');
      }
    } catch (err) {
      const redirect = err?.response?.data?.redirect;
      const error = err?.response?.data?.error;
      if (redirect) {
        window.location.href = redirect;
        return;
      }
      alert(error || 'Q&A 상세를 불러오지 못했습니다.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div style={styles.loading}>로딩중...</div>;
  }

  if (!row) {
    return <div style={styles.loading}>데이터가 없습니다.</div>;
  }

  return (
    <SellerLayout shopName="">
      <h2 style={styles.title}>Q&A 상세보기</h2>

      <table style={styles.table}>
        <tbody>
          <tr>
            <th style={styles.th20}>작성자</th>
            <td style={styles.td}>{row.user_id}</td>
          </tr>
          <tr>
            <th style={styles.th20}>상품</th>
            <td style={styles.td}>{row.product_name || ''}</td>
          </tr>
          <tr>
            <th style={styles.th20}>질문</th>
            <td style={styles.td}>
              {row.is_secret ? (
                '🔒 비밀글'
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: String(row.question || '').replace(/\n/g, '<br>')
                  }}
                />
              )}
            </td>
          </tr>
          <tr>
            <th style={styles.th20}>등록일</th>
            <td style={styles.td}>{row.created_at}</td>
          </tr>
          <tr>
            <th style={styles.th20}>답변</th>
            <td style={styles.td}>
              {row.answer ? (
                <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: String(row.answer || '').replace(/\n/g, '<br>')
                    }}
                  />
                  <div style={styles.mutedText}>답변일: {row.answered_at}</div>
                </>
              ) : (
                <span style={styles.dangerText}>아직 답변이 등록되지 않았습니다.</span>
              )}
            </td>
          </tr>
        </tbody>
      </table>

      <a href={`/seller/qna/edit?id=${row.id}`} style={styles.primaryBtn}>수정하기</a>
      <a href="/seller/qna/list" style={styles.secondaryBtn}>목록으로</a>
    </SellerLayout>
  );
};

const styles = {
  loading: { padding: '40px' },
  title: {
    marginTop: '20px',
    marginBottom: '24px',
    fontWeight: 'bold',
    borderBottom: '2px solid #dee2e6',
    paddingBottom: '10px',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginBottom: '16px',
  },
  th20: {
    width: '20%',
    border: '1px solid #dee2e6',
    padding: '12px',
    background: '#f8f9fa',
    textAlign: 'left',
    verticalAlign: 'middle',
  },
  td: {
    border: '1px solid #dee2e6',
    padding: '12px',
    verticalAlign: 'middle',
  },
  mutedText: {
    marginTop: '6px',
    color: '#6c757d',
  },
  dangerText: {
    color: '#dc3545',
  },
  primaryBtn: {
    display: 'inline-block',
    textDecoration: 'none',
    background: '#0d6efd',
    color: '#fff',
    padding: '10px 16px',
    borderRadius: '6px',
    marginRight: '8px',
  },
  secondaryBtn: {
    display: 'inline-block',
    textDecoration: 'none',
    background: '#6c757d',
    color: '#fff',
    padding: '10px 16px',
    borderRadius: '6px',
  },
};

export default SellerQnaView;